import { render, staticRenderFns } from "./epb-modal.component.vue?vue&type=template&id=4ee97782"
import script from "./epb-modal.component.vue?vue&type=script&lang=ts"
export * from "./epb-modal.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports